import * as Yup from "yup";

export const OrderCreationValidationSchema = Yup.object().shape({
  //   total_amount: Yup.number().required("Total amount is required"),
  status: Yup.string().required("Status is required"),
  //   branch_id: Yup.number().required("Branch is required"),
  //   payment_method_id: Yup.number().required("Payment method is required"),
  customer_id: Yup.string().required("Customer is required"),
  //   order_items: Yup.array().of(
  //     Yup.object().shape({
  //       product_id: Yup.number().required("Product is required"),
  //       quantity: Yup.number().required("Quantity is required"),
  //       price: Yup.number().required("Price is required"),
  //       discount_percentage: Yup.number().required(
  //         "Discount percentage is required"
  //       ),
  //       discount_amt: Yup.number().required("Discount amount is required"),
  //     })
  //   ),
});
